function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90pt",
    height: "90pt",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 69.03125 45.988281 C 70.289062 45.269531 71.640625 47.070312 71.101562 48.871094 C 69.03125 56.519531 62.730469 70.921875 45.449219 70.921875 C 26.820312 70.921875 20.699219 56.339844 18.71875 48.78125 C 18.269531 46.980469 19.53125 45.269531 20.789062 45.988281 L 20.96875 45.988281 C 36.359375 54.628906 53.550781 54.628906 69.03125 45.988281 Z M 45 5.398438 C 66.871094 5.398438 84.601562 23.128906 84.601562 45 C 84.601562 66.871094 66.871094 84.601562 45 84.601562 C 23.128906 84.601562 5.398438 66.871094 5.398438 45 C 5.398438 23.128906 23.128906 5.398438 45 5.398438 Z M 45 7.921875 C 65.429688 7.921875 82.078125 24.570312 82.078125 45 C 82.078125 65.429688 65.429688 82.078125 45 82.078125 C 24.570312 82.078125 7.921875 65.429688 7.921875 45 C 7.921875 24.570312 24.570312 7.921875 45 7.921875 Z M 32.761719 41.488281 C 29.070312 41.488281 26.011719 36.71875 26.011719 30.871094 C 26.011719 25.019531 29.070312 20.25 32.761719 20.25 C 36.539062 20.25 39.511719 25.019531 39.511719 30.871094 C 39.511719 36.71875 36.539062 41.488281 32.761719 41.488281 Z M 55.078125 41.488281 C 51.390625 41.488281 48.421875 36.71875 48.421875 30.871094 C 48.421875 25.019531 51.390625 20.25 55.078125 20.25 C 58.859375 20.25 61.828125 25.019531 61.828125 30.871094 C 61.828125 36.71875 58.859375 41.488281 55.078125 41.488281 Z M 55.078125 41.488281 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.3b41b77980d5801f8656c079a2d63b5a.svg";
export { ForwardRef as ReactComponent };